import {
  components,
} from 'react-select';

import {
  Flex,
  icons,
} from 'web-styled';

import * as S from './styled';

const ClientSearchOption = ({ label, innerRef, selectProps, data, ...restProps }) => (
  <components.Option {...selectProps} {...restProps}>
    <Flex
      align="center"
      justify="flex-start"
    >
      <S.SearchOption ref={innerRef}>
        <Flex
          align="center"
        >
          <S.ItemIcon
            color={data.color}
          >
            {data.avatar
              ? (
                <S.Avatar
                  src={data.avatar}
                  alt=""
                />
              ) : (
                <S.AvatarPlaceHolder
                  src={icons.clientAvatarPlaceHolder}
                  alt=""
                  color={data.color}
                />
              )}
          </S.ItemIcon>
          <S.Label>
            {label}
          </S.Label>
        </Flex>
      </S.SearchOption>
    </Flex>
  </components.Option>
);

export default ClientSearchOption;
